<template>
  <!-- 下部开始 -->
  <div id="item8389fda0-3e05-11ec-a2e6-953464dcce14">
    <table class="tableLeft" rules="none">
      <thead>
        <tr>
          <th>序号</th>
          <th>企业名称</th>
          <th>岗位名称</th>
          <th>岗位数量</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in resData" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.dwname }}</td>
          <td>{{ item.gangweiName }}</td>
          <td>{{ item.gangweiNum }}个</td>
        </tr>
      </tbody>
    </table>

    <!-- <div id="echartBar4"></div> -->
  </div>
  <!-- 下部结束 -->
</template>

<script>
import axios from 'axios';
import { baseURL } from '../../../api/base';
export default {
  mounted () {
    this.gettable1()
  },
  data () {
    return {
      // 模拟数据
      resData: []
    }
  },
  methods: {
    gettable1:function()
    {
         // 获取数据
    axios.get(baseURL+'/table/getright2').then(response => {
      this.resData = response.data;
      // 更新图表
      //myChart.setOption(option);
    });
    }
  }
}
</script>

<style scoped>
#bottomWrap {
  display: flex;
  position: absolute;
  left: 5px;
  top: 690px;
  width: 1690px;
  height: 365px;
  z-index: 7;
  opacity: 1;
  transform: rotate(0deg);
  margin-left: 110px;
  background: rgba(255, 255, 255, 0);
  border: 0px solid #2ed64a;
  border-radius: 0px;
  padding: 0px;
}
#item8389fda0-3e05-11ec-a2e6-953464dcce14 {
  height: 600px;
  width: 100%;
  /* left: 110px; */
  /* margin-left: 110px; */
}
.tableLeft {
  max-height: 350px;
  background-color: #0b3047;
  font-size: 16px;
  color: #fff;
  width: 100%;
}
.tableLeft thead tr:nth-child(1) {
  height: 40px;
  background-color: #0f3055;
  text-align: center;
}
.tableLeft tr th:nth-child(1) {
  width: 70px;
}
.tableLeft tr th:nth-child(2) {
  width: 280px;
}
.tableLeft tr th:nth-child(3) {
  width: 100px;
}
.tableLeft tr th:nth-child(4) {
  width: 140px;
}
.tableLeft thead tr .progress {
  width: 120px;
}
.tableLeft tbody tr td {
  position: relative;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.tableLeft tbody tr td:nth-child(2) {
  text-align: center;
}
.tableLeft tbody tr td div {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  width: 100%;
  height: 18px;
}
.tableLeft tbody tr td .activeProgress {
  background-color: #1ec7d7;
}
#echartBar4 {
  width: 1100px;
  height: 354px;
}
</style>
